import { useEffect } from "react";

// Mostra o aviso nativo do navegador ("tem certeza que quer sair?") se o
// usuário tentar fechar ou recarregar a aba enquanto `ativo` for true —
// evita perder um upload em andamento sem querer.
export function useAvisoAoSair(ativo) {
  useEffect(() => {
    if (!ativo) return;
    const handler = (e) => { e.preventDefault(); e.returnValue = ""; };
    window.addEventListener("beforeunload", handler);
    return () => window.removeEventListener("beforeunload", handler);
  }, [ativo]);
}
